export const contactsData = {
  email: "harshrajpal2k18@gmail.com",
  phone: "+917015469345",
  address: "Vellore Insitute of Technology, Vellore, Tamil Nadu, India",

  sheetAPI: "",
};
